import React from 'react';
import PropTypes from 'prop-types';

import ResultsFrom from '@Pages/Alerts/AlertsComponents/ResultsFrom';
import ResultEditButtons from '@Pages/Alerts/AlertsComponents/ResultsFrom/ResultEditButtons';
import AlertContextTitle from '@Pages/Alerts/AlertsComponents/AlertContextTitle';
import AlertDescription from '@Pages/Alerts/AlertsComponents/AlertDescription';
import AlertSinceDate from '@Pages/Alerts/AlertsComponents/AlertSinceDate';

import './AlertItem.scss';

export default function AlertItem({
  context,
  className,
  name,
  dbName,
  results,
  id,
  alert,
  lastSaved,
  structures,
  description,
  openStructureDialog,
  fetchResultsInfo,
  selectResultOfAlert,
  selectedRunId,
  selectedResultDate,
  selectedResultHits,
  handleViewDeleteModal,
  openEditAlert,
}) {
  return (
    <section id={id} data-alert-name={name} className={`alert-wrapper alert-context-${context}`}>
      <div className="alert-block alert-left-block">
        <AlertContextTitle context={context} className={className} />
        <AlertSinceDate lastSaved={lastSaved} />
      </div>
      <div className="alert-block alert-middle-block">
        <h3 className="alert-middle-block--name u-els-font-size-h4">
          {name} - in {dbName}
        </h3>
        <AlertDescription
          showLabel="Show details"
          hideLabel="Hide details"
          description={description}
          structures={structures}
          openStructureDialog={openStructureDialog}
        />
      </div>
      <div className="alert-block alert-right-block">
        <ResultsFrom
          id={id}
          results={results}
          alert={alert}
          className={className}
          selectedResultDate={selectedResultDate}
          selectedResultHits={selectedResultHits}
          selectedRunId={selectedRunId}
          fetchResultsInfo={fetchResultsInfo}
          selectResultOfAlert={selectResultOfAlert}
        />
        <ResultEditButtons id={id} handleViewDeleteModal={handleViewDeleteModal} openEditAlert={openEditAlert} />
      </div>
    </section>
  );
}

AlertItem.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  context: PropTypes.string,
  name: PropTypes.string.isRequired,
  dbName: PropTypes.string.isRequired,
  handleViewDeleteModal: PropTypes.func.isRequired,
  openEditAlert: PropTypes.func.isRequired,
};
